import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-66d75f52"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "containar"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-bg"
}, null, -1));

const _hoisted_3 = {
  class: "w"
};
const _hoisted_4 = {
  class: "main-warp"
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "list-warp"
};
const _hoisted_7 = {
  key: 0,
  class: "no-data"
};
import Header from '@/pages/components/Head.vue';
import Footer from '@/pages/components/Footer.vue';
import SideSelector from './components/SideSelector';
import TopSearch, { Sort } from './components/TopSearch';
import listItem from './components/ListItem/index.vue';
import { Empty } from 'zhs-components';
import usePage from './hooks/usePage';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const {
      getExcellentCaseList,
      excellentCaseFilter,
      excellentCaseSettingGet
    } = inject('$http');
    const menuInfo = ref({});
    provide('menuInfo', menuInfo);
    const userInfo = ref(null);

    const getUserInfo = data => {
      userInfo.value = data;
    };

    const searchInfo = reactive({
      keyword: '',
      schoolyear_id: '',
      semester_id: '',
      organ_id: '',
      classify_id: '',
      sort_type: Sort.COMPREHENSIVE
    });
    const caseList = ref([]);
    const selectInfo = ref(null);
    const settingInfo = ref(null);
    provide('settingInfo', settingInfo);
    const {
      pageIndexChange,
      pageInfo
    } = usePage(() => {
      getExcellentCaseListApi();
    });

    const updateSelector = data => {
      console.log('data :>> ', data);
      Object.assign(searchInfo, data);
      getSelectListApi();
      getExcellentCaseListApi();
    };

    const updateSearch = data => {
      console.log('data :>> ', data);
      Object.assign(searchInfo, data);
      getSelectListApi();
      getExcellentCaseListApi();
    };

    const getExcellentCaseListApi = async () => {
      pageInfo.pageLimit = 9;
      const res = await getExcellentCaseList({ ...searchInfo,
        '_pageable.page': pageInfo.pageIndex - 1,
        '_pageable.size': pageInfo.pageLimit
      });
      console.log('res :>> ', res);
      caseList.value = res.content;
      pageInfo.rows = +res.totalElements;
    };

    const getSelectListApi = async () => {
      const res = await excellentCaseFilter({ ...searchInfo
      });
      selectInfo.value = res;
    };

    const excellentCaseSettingGetApi = async () => {
      const res = await excellentCaseSettingGet();
      settingInfo.value = res;
      searchInfo.sort_type = res.sort_type;
    };

    onMounted(async () => {
      await excellentCaseSettingGetApi();
      await getSelectListApi();
      await getExcellentCaseListApi();
    });
    return (_ctx, _cache) => {
      const _component_ElPagination = _resolveComponent("ElPagination");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Header, {
        menuCode: "10501",
        menuInfo: menuInfo.value,
        "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => menuInfo.value = $event),
        onGetUserInfo: getUserInfo
      }, null, 8, ["menuInfo"]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_unref(TopSearch), {
        onUpdateSearch: updateSearch,
        menuInfo: menuInfo.value
      }, null, 8, ["menuInfo"]), _createElementVNode("main", _hoisted_4, [_createVNode(_unref(SideSelector), {
        style: {
          flexShrink: 0
        },
        info: selectInfo.value,
        onUpdateSelector: updateSelector
      }, null, 8, ["info"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caseList.value, item => {
        return _openBlock(), _createBlock(listItem, {
          key: item.id,
          caseData: item
        }, null, 8, ["caseData"]);
      }), 128)), false ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(Empty))])) : _createCommentVNode("", true)]), _unref(pageInfo).rows > _unref(pageInfo).pageLimit ? (_openBlock(), _createBlock(_component_ElPagination, {
        key: 0,
        class: "course-pagination",
        background: "",
        layout: "prev, pager, next",
        "prev-text": "上一页",
        "next-text": "下一页",
        "page-size": _unref(pageInfo).pageLimit,
        onCurrentChange: _unref(pageIndexChange),
        "current-page": _unref(pageInfo).pageIndex,
        total: 0 || _unref(pageInfo).rows
      }, null, 8, ["page-size", "onCurrentChange", "current-page", "total"])) : _createCommentVNode("", true)])])]), _createVNode(Footer)]);
    };
  }

});